import { MagicRedirectParam, MagicRedirectParams } from '@internal/auth/types';

export function getAuthRedirectParam<T extends string>(
    value: string,
    param: MagicRedirectParam
): T | null {
    const params: MagicRedirectParams | null = value ? JSON.parse(value) : null;
    return params && typeof params === 'object' ? (params[param] as T) : null;
}
